window.prazdnyKosikNadpis = [
    { language: "cs", text: "Váš košík je prázdný." },
    { language: "en", text: "Your cart is empty." }
];

window.prazdnyKosikPerex = [
    { language: "cs", text: "Pokud nevíte, jaký produkt vybrat, zkuste se podívat do naší poradny nebo zavolejte přímo nám, rádi vám pomůžeme." },
    { language: "en", text: "If you don't know which product to choose, try looking at our guide or call us directly, we are happy to help." }
];

window.primaryButtonText = [
    { language: "cs", text: "Zpět do obchodu", url: "/" },
    { language: "en", text: "Back to shop", url: "/" }
];

window.secondaryButtonText = [
    { language: "cs", text: "Kontakty", url: "/kontakty" },
    { language: "en", text: "Contacts", url: "/contacts" }
];

window.emailPerexText = [
    { language: "cs", text: "Odpovídáme do 24 hodin" },
    { language: "en", text: "We respond within 24 hours" }
];

window.recenzeBtnText = [
    { language: "cs", text: "Zobrazit více" },
    { language: "en", text: "Show more" }
];

window.hodnoceniNadpis = [
    { language: "cs", text: "Hodnocení obchodu" },
    { language: "en", text: "Store rating" }
];

window.dopravaVHlavicce = [
    { language: "cs", text: "Doprava zdarma od 999 Kč" },
    { language: "en", text: "Free shipping from 999 CZK" }
];

window.kosik = [
    { language: "cs", text: "Košík" },
    { language: "en", text: "Cart" }
];

window.newsletterNadpis = [
    { language: "cs", text: "NEWSLETTER" },
    { language: "en", text: "NEWSLETTER" }
];

window.availabilityTitle = [
    { language: "cs", text: "Dostupnost" },
    { language: "en", text: "Availability" }
];

window.labelsTitle = [
    { language: "cs", text: "Štítky" },
    { language: "en", text: "Labels" }
];

window.extraGiftTitles = [
    { language: "cs", text: "Slevový kód" },
    { language: "en", text: "Discount code" }
];

window.deliveryCartTitle = [
    { language: "cs", text: "Způsob dopravy" },
    { language: "en", text: "Delivery method" }
];

window.paymentCartTitle = [
    { language: "cs", text: "Způsob platby" },
    { language: "en", text: "Payment method" }
];

window.itemsCartTitle = [
    { language: "cs", text: "Nákupní košík" },
    { language: "en", text: "Shopping cart" }
];

window.backCartButton = [
    { language: "cs", text: "Zpět" },
    { language: "en", text: "Back" }
];

window.productDetailAddBtn = [
    { language: "cs", text: "Do košíku" },
    { language: "en", text: "Add to cart" }
];

window.productDetailFavourite = [
    { language: "cs", text: "Přidat do oblíbených", remove: "Odebrat" },
    { language: "en", text: "Add to favourites", remove: "Remove" }
];

window.filterBtnText = [
    { language: "cs", text: "Detailní filtrace" },
    { language: "en", text: "Filter" }
];

window.filterBtnTextClose = [
    { language: "cs", text: "Zavřít filtraci" },
    { language: "en", text: "Close filtering" }
];

window.tabulkaVelikostiUmisteni = [
    "Velikost ponožek",
    "Veľkosť ponožok",
    "Velikost",
    "Veľkosť"
];

window.tabulkaVelikostiTextOdkaz = [
    { language: "cs", text: "Tabulka velikostí", url: "/pruvodce-velikosti/" },
    { language: "en", text: "Size chart", url: "/pruvodce-velikosti/" }
];

window.variantBtn = [
    { language: "cs", text: "Vybrat variantu" },
    { language: "en", text: "Choose variant" }
];

window.newsBtnText = [
    { language: "cs", text: "Přečíst článek" },
    { language: "en", text: "Read article" }
];

window.alternativeNadpis = [
    { language: "cs", text: "Podobné produkty" },
    { language: "en", text: "Similar products" }
];

window.naposledyProhlizene = [
    { language: "cs", text: "Naposledy prohlížené" },
    { language: "en", text: "Recently viewed" }
];

window.instagramTitle = [
    { language: "cs", text: "Sledujte náš Instagram <a href='https://www.instagram.com/pwb_watchdeals/' target='_blank'> #pwb_watchdeals</a>" },
    { language: "en", text: "Follow our Instagram <a href='https://www.instagram.com/pwb_watchdeals/' target='_blank'> #pwb_watchdeals</a>" }
];

window.kosik = [
    { language: "cs", text: "Celková velikost souborů překračuje maximální velikost 25 MB." },
    { language: "en", text: "The total file size exceeds the maximum size of 25 MB." }
];

window.maxFileSize = [
    { language: "cs", text: "Soubor překračuje maximální velikost 10 MB." },
    { language: "en", text: "The file exceeds the maximum size of 10 MB." }
];

window.maxFiles = [
    { language: "cs", text: "Nahráváte více než 6 souborů. Následující soubory nebudou nahrány:" },
    { language: "en", text: "You are uploading more than 6 files. The following files will not be uploaded:" }
];

window.newsLetterTitle = [
    { language: "cs", text: "Čas se mění. Zůstaňte v obraze." },
    { language: "en", text: "Times are changing. Stay informed." }
];

window.newsLetterPerex = [
    { language: "cs", text: "Získejte exkluzivní novinky, speciální nabídky a přehled o nejnovějších modelech hodinek přímo do své schránky. Přihlaste se k odběru našeho newsletteru." },
    { language: "en", text: "Get exclusive news, special offers, and an overview of the latest watch models directly to your inbox. Subscribe to our newsletter." }
];

window.newsLetterBtn = [
    { language: "cs", text: "Odebírat newsletter" },
    { language: "en", text: "Subscribe newsletter" }
];

window.specificationTabText = [
    { language: "cs", text: "Specifikace" },
    { language: "en", text: "Specifications" }
];

window.subcategoriesBtnCategory = [
    { language: "cs", text: "Značky" },
    { language: "en", text: "Brands" }
];

window.codeText = [
    { language: "cs", text: "Reference: " },
    { language: "en", text: "Ref. no. " }
];

window.filteringMobileBtnText = [
    { language: "cs", text: "Filtrovat" },
    { language: "en", text: "Filter by" }
];